import React from 'react';
import { motion } from 'framer-motion';
import './About.css';
// Using a hair salon image from Unsplash

const About = () => {
  return (
    <section id="about" className="about section">
      <div className="container">
        <div className="about-content">
          <motion.div 
            className="about-image"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <img src="https://images.unsplash.com/photo-1559599101-f09722fb4948?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80" alt="Professional hair styling" />
          </motion.div>
          <motion.div 
            className="about-text"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2>Why Choose BukkyDebrand?</h2>
            <p>Located at Ekumi Plaza (New York Line), BukkyDebrand has been providing premium hair products and services with a commitment to quality and customer satisfaction.</p>
            
            <div className="features">
              {[
                { icon: 'fas fa-award', title: 'Premium Quality', desc: 'We source only the finest human hair and synthetic materials for our wigs and weaves.' },
                { icon: 'fas fa-clock', title: 'Expert Service', desc: 'Professional styling and installation services with years of experience.' },
                { icon: 'fas fa-heart', title: 'Customer Care', desc: 'Personalized service to help you find the perfect hair solution for your needs.' }
              ].map((feature, index) => (
                <motion.div 
                  key={index}
                  className="feature"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.2, duration: 0.6 }}
                >
                  <div className="feature-icon">
                    <i className={feature.icon}></i>
                  </div>
                  <div className="feature-content">
                    <h4>{feature.title}</h4>
                    <p>{feature.desc}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
          
          <motion.div 
            className="about-stats"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            {[
              { number: '8+', label: 'Years Experience' },
              { number: '2000+', label: 'Happy Customers' },
              { number: '100%', label: 'Quality Guarantee' }
            ].map((stat, index) => (
              <motion.div 
                key={index}
                className="stat"
                whileHover={{ scale: 1.05 }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                <h3>{stat.number}</h3>
                <p>{stat.label}</p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;